import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "pms-avatar-nominative",
  templateUrl: "avatar-nominative.component.html",
  standalone: false
})
export class AvatarNominativeComponent implements OnInit {
  @Input() text!: string;
  @Input() size!: number;
  @Input() active!: boolean;
  @Input() applySizeToFont!: boolean;

  display: string = "";

  ngOnInit(): void {
    if (!this.text) {
      return;
    }

    const splits = this.text.split(" ");

    const first = splits.length > 0 ? splits[0][0].toUpperCase() : "";
    const second =
      splits.length > 1
        ? splits[1][0].toUpperCase()
        : splits[0].length > 1
          ? splits[0][1].toUpperCase()
          : "";

    this.display = `${first}${second}`;
  }
}
